import getPathToBecomeAdjacent from './getPathToBecomeAdjacent/index.js';
import getPathToApproach from './getPathToApproach.js';
import getPathToPosition from './getPathToPosition.js';
import getPathToBecomeAdjacentToPosition from './getPathToBecomeAdjacentToPosition.js';
import getReachablePathToPosition from './getReachablePathToPosition.js';
function getReachablePath(agentUnit, enemyUnit, hexProperties, rules, allUnits, mapHexes, terrainPreferences) {
    if (hexProperties.getDistance(agentUnit.position, enemyUnit.position) >
        agentUnit.movementPoints + 1) {
        return null;
    }
    return getPathToBecomeAdjacent(agentUnit, enemyUnit, hexProperties, rules, allUnits, mapHexes, terrainPreferences);
}
export { getPathToBecomeAdjacent, getPathToApproach, getPathToPosition, getPathToBecomeAdjacentToPosition, getReachablePathToPosition, };
export default getReachablePath;
